import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { supplierApi, type Supplier } from '../../api/supplier';

export function ContractManagerPage() {
  const [suppliers, setSuppliers] = useState<Supplier[]>([]);
  const [contracts, setContracts] = useState<unknown[]>([]);

  useEffect(() => {
    void supplierApi.listSuppliers().then(setSuppliers);
  }, []);

  async function loadContracts(id: string) {
    setContracts(await supplierApi.listContracts(id));
  }

  return (
    <div className="mx-auto max-w-6xl p-6">
      <Link to="/suppliers" className="text-sm text-slate-600 hover:underline">← Supplier hub</Link>
      <h1 className="mt-2 text-2xl font-semibold">Contract manager</h1>
      <ul className="mt-4 space-y-2">
        {suppliers.map((s) => (
          <li key={s.id}>
            <button type="button" onClick={() => void loadContracts(s.id)}
              className="rounded border px-3 py-2 text-sm">View contracts — {s.supplier_code}</button>
          </li>
        ))}
      </ul>
      {contracts.length > 0 && (
        <pre className="mt-4 overflow-auto rounded border p-3 text-xs">{JSON.stringify(contracts, null, 2)}</pre>
      )}
    </div>
  );
}
